/* eslint-disable */
import React, { useState } from "react";

import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Tooltip,
} from "@chakra-ui/react";
import { CheckIcon, CloseIcon, QuestionIcon } from "@chakra-ui/icons";
import { useTranslation, withTranslation, Trans } from "react-i18next";

export interface B4FTextProps {
  id: string;
  label: string;
  placeholder?: string;
  value: string;
  onChange: any;
  onBlur?: any;
  isRequired: boolean;
  isDisabled?: boolean;
  isInvalid?: boolean;
  tooltip?: string;
  visible: boolean;
  defaultValue?: any;
}

export const B4FText: React.FC<B4FTextProps> = (props) => {
  const [value, setValue] = useState(props.value);
  const [touched, setTouched] = useState(false);
  const [highlight, setHighlight] = useState(false);
  const { t, i18n } = useTranslation();

  React.useEffect(() => {
    setValue(props.value);

    if (props.isRequired) {
      if (!isValid(value)) {
        setHighlight(true);
      } else {
        setHighlight(false);
      }
    } else {
      setHighlight(false);
    }
  }, [props.value]);

  function isValid(value: string): boolean {
    return props.isRequired && value !== "" && value !== null;
  }

  function handleChange(e: any) {
    props.onChange({
      id: props.id,
      type: "text",
      value: e.target.value,
      valid: isValid(e.target.value),
      required: props.isRequired,
    });
    setValue(e.target.value);
    setTouched(true);
  }

  function handleBlur(e: any) {
    if (props.onBlur) {
      props.onBlur({
        id: props.id,
        type: "text",
        value: e.target.value,
        valid: isValid(e.target.value),
        required: props.isRequired,
      });
    }

    if (props.isRequired) {
      if (!isValid(value)) {
        setHighlight(true);
      } else {
        setHighlight(false);
      }
    } else {
      setHighlight(false);
    }
  }

  let rightElement;

  if (isValid(value)) {
    rightElement = (
      <InputRightElement>{<CheckIcon color="green.500" />}</InputRightElement>
    );
  } else if (props.isRequired && touched) {
    rightElement = (
      <InputRightElement>{<CloseIcon color="red.500" />}</InputRightElement>
    );
  }

  if (props.visible) {
    return (
      <FormControl
        key={props.label}
        mb={2}
        isRequired={props.isRequired}
        isDisabled={props.isDisabled}
      >
        <Flex>
          <FormLabel fontSize={"md"}>{t(props.label)}</FormLabel>
          {props.tooltip && props.tooltip !== "" ? (
            <Tooltip
              label={props.tooltip}
              fontSize="md"
              bg="brand.white"
              color="brand.text"
            >
              {props.isDisabled ? (
                <QuestionIcon color="brand.grey" />
              ) : (
                <QuestionIcon color="brand.bf2" />
              )}
            </Tooltip>
          ) : null}
        </Flex>

        <InputGroup>
          <Input
            color="#636E95"
            id={props.id}
            type="text"
            bg="brand.inputBackground"
            // placeholder={t(`${props.placeholder}`)}
            focusBorderColor="brand.bf3"
            defaultValue={props.defaultValue}
            borderWidth="1px"
            borderColor="brand.inputBorder"
            value={value ? value : ""}
            onChange={handleChange}
            onBlur={handleBlur}
            errorBorderColor="brand.bf2"
            isInvalid={highlight}
          />
          {rightElement}
        </InputGroup>
      </FormControl>
    );
  } else {
    return null;
  }
};
